import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import { MfButton } from "../../components/Button"
import { MfFontIcon } from "../../foundations/FontIcon"

const BackButtonSmall = styled(MfButton).attrs({
  text: true,
  color: "white",
})`
  padding: ${({ theme }) => theme.spacing(3)};
`

const DisplayBackButtons = styled.div`
  ${({ theme }) => css`
    ${theme.media.phone`
        .desktop-button {
          display: none;
        }
        .mobile-button {
          display: block;
        }
    `}
    ${theme.media.desktop`
        .desktop-button {
          display: block;
        }
        .mobile-button {
          display: none;
        }
    `}
  `}
`

export function BackButton({ children = "Back", ...props }) {
  return (
    <DisplayBackButtons>
      <div className="desktop-button">
        <MfButton text {...props}>
          <MfFontIcon icon="fonticons-chevron-left" />
          {children}
        </MfButton>
      </div>
      <div className="mobile-button">
        <BackButtonSmall {...props}>
          <MfFontIcon icon="fonticons-arrow-back" />
        </BackButtonSmall>
      </div>
    </DisplayBackButtons>
  )
}

BackButton.propTypes = {
  children: PropTypes.any,
}
